/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit User/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function User({
  children,
  viewPath = "/DesignSystem/TasksFilters/Patient/Content/SearchResult/Content/User"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let filtersPatientsValueData = fromData.useDataValue({ viewPath,
context: 'filters',
path: 'patients',
})
let personPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'patient._id',
})
let aggregateData = fromHelpers.isChecked(filtersPatientsValueData, personPatientIdValueData)
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let personValueData = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromFormat.initials,
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let personValueData1 = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromHelpers.getName,
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let personValueData2 = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromHelpers.maybeGetEmail,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let personValueData3 = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromHelpers.maybeGetPhone,
})
  return (<React.Fragment
>
<button
  data-testid="User.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--mb-1-bE5X': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaCheckboxInput
  viewPath={`${viewPath}/TysiaCheckboxInput`}
 data="filters.patients"
 data="person.patient._id"
 aggregate="./helpers.js isChecked"
 value={aggregateData}
 size="small"
/>
<div
  data-testid="User.Vertical"
  data-view-path={viewPath}
 style={{'--ml-2-bE5X': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bc-3-bE5X': dtColorsNeutral200,'--btlr-4-bE5X': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--btrr-5-bE5X': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--bblr-6-bE5X': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--bbrr-7-bE5X': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--mr-8-bE5X': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--h-9-bE5X': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--w-10-bE5X': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral700}
 data="person"
 format="/Data/format.js initials"
 text={personValueData}
/>
</div>
<div
  data-testid="User.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-11-bE5X': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 backgroundColor={dtColorsNeutral900}
 data="person"
 format="helpers.js getName"
 text={personValueData1}
/>
<div
  data-testid="User.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-11-bE5X': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 data="person"
 format="helpers.js maybeGetEmail"
 text={personValueData2}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 data="person"
 format="helpers.js maybeGetPhone"
 text={personValueData3}
/>
</div>
</div>
</button>
{children}
</React.Fragment>)
}